<template>
	<TwoColumns
		columns-order="flex-col lg:flex-row"
		first-column-class="contained-section items-center flex"
		second-column-class="contained-section"
	>
		<template #first>
			<CarbarImage
				image="img/electric-vehicle/img-sell_your_car_to_us_and_upgrade_to_ev.webp"
				alt-text="Why sell your car to carbar"
			/>
		</template>
		<template #second>
			<div class="flex w-full flex-col">
				<h2>Why sell your car to carbar?</h2>
				<div class="flex flex-col gap-6">
					<div v-for="(list, index) in lists" :key="index">
						<div class="mb-4 text-xl font-medium text-gray-700">
							{{ list.header }}
						</div>
						<div>
							{{ list.content }}
							<span v-if="list.link">
								<CarbarLink
									class="cursor-pointer"
									:text="list.link"
									@click="goToPageAndScroll('/sell-my-car')"
								/>
								<span>.</span>
							</span>
						</div>
					</div>
				</div>
				<TermsAndConditions :is-full-width="false" class="mt-8">
					*
					<CarbarLink
						href="/terms-and-conditions/instant-valuation"
						font-size="text-sm"
						text="Terms and conditions"
						target="_blank"
					/>
					apply.
				</TermsAndConditions>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const lists = [
	{
		header: 'Total convenience',
		content: `Selling a car is a hassle. Answering countless phone calls, waiting for people who don't show up, and inviting strangers to your home. We can save you the stress and the risk of a private sale.`,
	},
	{
		header: 'Competitive offers',
		content:
			'Get the best offers possible for your vehicle, determined by its fair market value, ensuring you receive the highest value for your car.',
		link: 'See criteria here',
	},
	{
		header: `Drop it off or we'll pick it up`,
		content:
			'Payments are made in advance of, or on scheduled collection or drop off.',
	},
]

const router = useRouter()
const route = useRoute()
const goToPageAndScroll = async (url) => {
	if (route.path !== url) {
		await router.push(url)
		nextTick(() => {
			scrollTo('#car-criteria')
		})
	} else {
		scrollTo('#car-criteria')
	}
}
</script>
